import React from 'react';
import Scrollbar from 'react-smooth-scrollbar';

class Scrollbars extends React.Component {

  componentDidMount() {
    const { scrollbar } = this.$container;
    const _this = this;
    setTimeout(() => {
      if (_this.props.scrollBarScrollTo) {
        scrollbar.scrollIntoView(_this.props.scrollBarScrollTo, {
          offsetLeft: 0,
          offsetBottom: 0,
          alignToTop: true,
          onlyScrollIfNeeded: false,
        });
      }
    },1000);
  }

  render() {
    const { id, className, style, continuousScrolling, alwaysShowTracks, children } = this.props;
    return (
      <Scrollbar 
        id={id}
        className={className}
        style={style}
        continuousScrolling={continuousScrolling}
        alwaysShowTracks={alwaysShowTracks}
        ref={c => this.$container = c}>
        {children}
      </Scrollbar>
    );
  }
}

export default Scrollbars;



// WEBPACK FOOTER //
// ./src/components/utility/customScrollBar.js